import request from '..'
export const getProjList = (params: any): Promise<any> => {
    return request({
        url: `/shop/room/list/detail`,
        method: 'get',
        params

    })
}

//获取商品
export const listNoPagefun = (): Promise<any> => {
    return request({
        url: `/goods/goodsinfo/listNoPage`,
        method: 'get',

    })
}

//获取项目
export const listNoPagexmfun = (params: any): Promise<any> => {
    return request({
        url: `/shop/item/getAllItemByTypeIdList`,
        method: 'get',
        params

    })
}

//员工服务员
export const employeelist = (params: any): Promise<any> => {
    return request({
        url: `/system/employee/v2/list`,
        method: 'get',
        params,
    })
}


//开单
export const openorder = (data: any): Promise<any> => {
    return request({
        url: `/v4/business/order`,
        method: 'post',
        data

    })
}

//取消订单
export const quxorderId = (id: any): Promise<any> => {
    return request({
        url: `/v4/business/cancel?detailId=${id}`,
        method: 'get',

    })
}

//下钟
export const endtimes = (id: any): Promise<any> => {
    return request({
        url: `/v4/business/end?detailId=${id}`,
        method: 'get',


    })
}

//上钟
export const uptimes = (params: any): Promise<any> => {
    return request({
        url: `/v4/business/start`,
        method: 'get',
        params

    })
}


//查看详情
export const eitdetail = (id: any): Promise<any> => {
    return request({
        url: `/v4/business/detail?orderId=${id}`,
        method: 'get',

    })
}


// 休息
export const restrest = (id: any): Promise<any> => {
    return request({
        url: `/shop/room/bed/rest/${id}`,
        method: 'get',


    })
}

// 打扫
export const rescleans = (id: any): Promise<any> => {
    return request({
        url: `/shop/room/bed/clean/${id}`,
        method: 'get',


    })
}

// 临时占用
export const restuse = (id: any): Promise<any> => {
    return request({
        url: `/shop/room/bed/use/${id}`,
        method: 'get',


    })
}

// 恢复空闲：
export const restore = (id: any): Promise<any> => {
    return request({
        url: `/shop/room/bed/restore/${id}`,
        method: 'get',


    })
}


//加钟
export const addtiembusiness = (data: any): Promise<any> => {
    return request({
        url: `/v4/business/add`,
        method: 'post',
        data

    })
}

//获取空的床位
export const drooList = (params: any): Promise<any> => {
    return request({
        url: `/shop/room/list/idle`,
        method: 'get',
        params

    })
}


//更换房间
export const changdrooList = (data: any): Promise<any> => {
    return request({
        url: `/v4/business/change`,
        method: 'post',
        data

    })
}
